import { RankingInfo } from '@/types'

export function getFullUrlPath(targetPath: string): string {
	let baseUrl = location.origin;
	const sessionKey = location.pathname.split('/')[1];
	const isCookieless = sessionKey && /\(S/i.test(sessionKey);
	if (isCookieless) {
		baseUrl += `/${sessionKey}`;

	}
	return baseUrl + '/' + targetPath;
}
export function replaceResource(resourceString: string, replaceString: string): string {
	if (!resourceString) {
		return ''
	}
	resourceString = resourceString.replace('{X}', replaceString)
	return resourceString
}
export function addCommas(strValue: string | number): string {
	const value: string = typeof strValue === 'string' ? strValue : `${strValue}`;

	return value.replace(/^(-?\d+)((\.\d*)?)$/, (s, s1, s2) => s1.replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,') + s2);
}

export const removeCommas = (value: string) => {
	return value ? value.replace(/,/g, '') : value;
}

export function getProgressPercentage(currentProgress: number, threshold: number): number {
	const percentage = Math.floor(currentProgress * 100 / threshold);
	return percentage < 0 ? 0 : percentage > 100 ? 100 : percentage;
}

export function getRankingHiddenName(custid: number, rankingInfo: RankingInfo): string {
	return custid === rankingInfo.CustId ? rankingInfo.CustName : `${rankingInfo.CustName.slice(0, 1)}******${rankingInfo.CustName.slice(-1)}`;
}

export const simplifyLanguageCode = (locale: string) => {
	return {
		'ar-EG': 'ar',
		'bn-BD': 'beng',
		'de-DE': 'de',
		'es-ES': 'es',
		'en-US': 'en',
		'fr-FR': 'fr',
		'hi-IN': 'hi',
		'id-ID': 'id',
		'it-IT': 'it',
		'ja-JP': 'jp',
		'km-KH': 'kh',
		'ko-KR': 'ko',
		'lo-LA': 'lao',
		'ms-MY': 'msa',
		'pt-BR': 'ptbr',
		'ta-IN': 'tam',
		'th-TH': 'th',
		'vi-VN': 'vn',
		'zh-CN': 'cs',
		'zh-TW': 'ch',
		'tr-TR': 'tr',
	}[locale] ?? 'en';
};